<template>
  <div class="purchase-confirm-container position-relative">
    <div class="d-flex justify-content-start align-items-start mb-4" @click="close()">
      <div class="back-button d-flex align-items-center" :class="isPhone ? 'ml-2' : 'ml-5'">
        <img src="../../images/arrow-left-small.svg" alt="Back" />
      </div>
    </div>
    <div class="top-banner mt-5">
      <div class="w-100 d-flex flex-column justify-content-center align-items-center">
        <i class="fa-regular fa-circle-check"></i>
        <p class="text-green text-center" :class="isPhone ? 'merriweather-reg-24' : 'merriweather-reg-40'">Merci pour votre confiance.</p>
        <p class="text-center raleway-reg-p15">Votre carte cadeau Hortense a bien été achetée et est prête à être offerte.</p>
        <p class="text-center raleway-reg-p15">Offrir Hortense, c'est offrir bien plus qu'un séjour : c'est proposer une parenthèse de détente responsable, une découverte authentique des plus belles régions de France, et l'accès à des privilèges exclusifs soigneusement imaginés pour sublimer chaque escapade — attentions sur-mesure, expériences locales, et services dédiés tout au long du séjour.</p>
      </div>
    </div>
    <div class="purchase-main-container w-100 h-100">
      <p class="raleway-semi-p18">DÉTAILS DE VOTRE COMMANDE</p>
      <div class="purchase-items-container">
        <div class="purchase-item">
          <div class="d-flex flex-column" style="gap: 10px;">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <p class="merriweather-reg-20">Carte Cadeau</p>
              </div>
            </div>
            <div class="d-flex flex-column" style="gap: 5px;">
              <span class="raleway-medi-p15">Montant : {{ effectiveGiftCardPurchase.amount }}€</span>
            </div>
            <div v-if="effectiveGiftCardPurchase.purchase_type === 'beneficiary'" class="d-flex flex-column" style="gap: 5px;">
              <span class="raleway-medi-p15">À l'attention de : {{ effectiveGiftCardPurchase.receiver.first_name }} {{ effectiveGiftCardPurchase.receiver.last_name }}</span>
              <span class="raleway-medi-p15">Email destinataire : {{ effectiveGiftCardPurchase.receiver.email }}</span>
            </div>
            <span class="raleway-semi-p15 mt-2">Montant total : {{ effectivePurchaseTotal }} €</span>
          </div>
        </div>
        <div class="border-bottom-black my-3"></div>
        <div class="d-flex flex-row justify-content-between mt-3 w-100">
          <span class="raleway-semi-p18">Montant total payé TTC</span>
          <span class="raleway-semi-p18">{{ effectivePurchaseTotal }} €</span>
        </div>
        <div class="info-container w-100" :class="isPhone ? 'mt-3' : 'mt-5'">
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-start">
              <img src="../../images/info.svg" v-set-alt/>
              <p class="raleway-semi-p15" :class="isPhone ? 'ml-2' : 'ml-3'">BESOIN D'AIDE ?</p>
            </div>
            <p class="mb-0 raleway-reg-p13">Notre équipe reste à votre écoute via WhatsApp ou par email à <a class="link-hortense" href="mailto:customercare@hortense.green">customercare@hortense.green</a> pour répondre à toutes vos questions.</p>
          </div>
        </div>
        <p class="raleway-bold-p15 mb-0 pt-3">Envie de prolonger l'évasion ?</p>
        <p class="raleway-reg-p15">Parcourez dès maintenant notre sélection d'hébergements de charme et commencez à rêver à votre prochaine escapade.</p>
        <div class="d-flex justify-content-center align-items-center pt-4">
          <button class="hortense-btn-primary" @click="redirectTo('/reservation-hotel')">Découvrez notre sélection</button>
        </div>
      </div>
    </div>
    <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-proposition-valeur-desktop-privilege.gif" alt="Club Hortense Banner" class="hortense-banner-img" style="width: 100%;" />
  </div>
</template>

<script>
export default {
  name: 'GiftcardConfirmed',
  props: {
    giftCardPurchase: {
      type: Object,
      required: false
    },
    purchaseTotal: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      localGiftCardPurchase: null,
      localPurchaseTotal: null
    };
  },
  
  mounted() {
    // Retrieve data from localStorage
    const storedPurchase = localStorage.getItem('giftcardPurchase');
    const storedTotal = localStorage.getItem('purchaseTotal');
    
    if (storedPurchase) {
      this.localGiftCardPurchase = JSON.parse(storedPurchase);
    }
    
    if (storedTotal) {
      this.localPurchaseTotal = JSON.parse(storedTotal);
    }
  },
  
  computed: {
    isPhone() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    },
    
    // Use localStorage data if props are not provided
    effectiveGiftCardPurchase() {
      return this.giftCardPurchase || this.localGiftCardPurchase || {};
    },
    
    effectivePurchaseTotal() {
      return this.purchaseTotal !== undefined ? this.purchaseTotal : this.localPurchaseTotal || 0;
    }
  },
  
  methods: {
    close() {
      window.history.back();
    },
    getPurchaseTypeLabel(type) {
      const labels = {
        'beneficiary': 'Cadeau pour quelqu\'un',
        'personal': 'Pour moi-même',
        'entreprise': 'Achat entreprise'
      };
      return labels[type] || type;
    },
    redirectTo(path) {
      window.open(path, '_blank');
    }
  },
}
</script>

<style scoped>

.purchase-confirm-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;

  .top-banner {
    min-height: 302px;
    max-height: fit-content;
    background-color: #A5D3AE21;
    padding: 40px 20% 40px 20%;

    @media screen and (max-width: 768px) {
      padding: 40px 10% 40px 10%;
    }

    i {
      font-size: 69px;
      color: #3B6152;
      margin-bottom: 20px;
    }
  }

  .text-green {
    color: #3B6152;
  }

  .purchase-main-container {
    padding: 50px 95px 50px 95px;

    @media screen and (max-width: 768px) {
      padding: 24px;
    }
  }

  .purchase-items-container {
    background-color: #F7F7F7A5;
    padding: 24px 72px 24px 72px;

    @media screen and (max-width: 768px) {
      padding: 16px 13px 16px 13px;
    }

    .purchase-item {
      margin-bottom: 10px;
    }
  }

  .border-bottom-gray {
    border-bottom: 0.5px solid #707070;
  }
  
  .border-bottom-black {
    border-bottom: 1px solid #000;
  }

  .info-container {
    padding: 25px;
    background-color: #A5D3AE48;
    min-height: 122px;
    max-height: fit-content;
    border-radius: 7px 7px 0px 7px;

    .link-hortense {
      color: #3B6152;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .back-button {
    width: 40px;
    height: 38px;
    border-radius: 5px;
    background: #00000029;

    img {
      width: 23px;
      margin-left: 8px;
    }
  }

}

@media screen and (max-width: 768px) {
  .back-button {
    width: 36px !important;
    height: 38px !important;

    img {
      margin-left: 0 !important;
      width: 20px !important;
    }
  }
}
</style>
